import { Injector } from "@angular/core";
import { EExecutor } from '@core/shared/access';
import { AccessService } from "./access/access.service";
import * as i0 from "@angular/core";
export let FrontendAccessServiceProvider = /*#__PURE__*/(() => {
  class FrontendAccessServiceProvider {
    constructor(injector) {
      this.injector = injector;
      // console.log('accessServieProvider',access)
    }
    get() {
      if (!this.access) this.access = this.injector.get(AccessService);
      return this.access;
    }
    static {
      this.ɵfac = function FrontendAccessServiceProvider_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FrontendAccessServiceProvider)(i0.ɵɵinject(i0.Injector));
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: FrontendAccessServiceProvider,
        factory: FrontendAccessServiceProvider.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return FrontendAccessServiceProvider;
})();
export let FrontendExecutorProvider = /*#__PURE__*/(() => {
  class FrontendExecutorProvider {
    get() {
      return EExecutor.user;
    }
    static {
      this.ɵfac = function FrontendExecutorProvider_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FrontendExecutorProvider)();
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: FrontendExecutorProvider,
        factory: FrontendExecutorProvider.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return FrontendExecutorProvider;
})();